module.exports = __webpack_public_path__ + "img/partner_culture1.bb5260e9.png";